<template>
        <div >
                <el-dialog
                        :visible.sync="dialogVisible"
                        width="70%"
                        :title="title"
                        append-to-body
                        :modal-append-to-body='false'
                    
                        :close-on-press-escape='false'
                        :close-on-click-modal="false"
                       
                        >

                        <avue-form
                                :option="option"
                                v-model="form"
                                v-if="dialogVisible"
                                ref="form"
                                
                                @submit="applyFor"
                                @error="formError"
                        >
                       <template slot="deptId">
                                <avue-input-tree  
                                v-model="form.deptId" 
                                :props='{ label: "title", value: "id" }'
                                placeholder="请选择部门"
                                :clearable="'false'" 
                                :disabled="disabled"
                                type="tree" :dic="deptList"></avue-input-tree>
                        
                        </template>
                        <template slot="energy1">
                               <el-input
                                v-model="form.energy1"
                                placeholder="请输入能耗指标"
                                :disabled="disabled"
                                @input="e=>energyInput(e,'energy1')"
                               ></el-input>
                        </template>
                        <template slot="energy2">
                               <el-input
                                v-model="form.energy2"
                                placeholder="请输入能耗指标"
                                :disabled="disabled"
                                @input="e=>energyInput(e,'energy2')"
                               ></el-input>
                        </template>
                        <template slot="energy3">
                               <el-input
                                v-model="form.energy3"
                                placeholder="请输入能耗指标"
                                :disabled="disabled"
                                @input="e=>energyInput(e,'energy3')"
                               ></el-input>
                        </template>
                        <template slot="energy4">
                               <el-input
                                v-model="form.energy4"
                                :disabled="disabled"
                                placeholder="请输入能耗指标"
                                @input="e=>energyInput(e,'energy4')"
                               ></el-input>
                        </template>
                        <template slot="energy5">
                               <el-input
                                v-model="form.energy5"
                                :disabled="disabled"
                                placeholder="请输入能耗指标"
                                @input="e=>energyInput(e,'energy5')"
                               ></el-input>
                        </template>
                        <template slot="energy6">
                               <el-input
                                v-model="form.energy6"
                                :disabled="disabled"
                                placeholder="请输入能耗指标"
                                @input="e=>energyInput(e,'energy6')"
                               ></el-input>
                        </template>
                        <template slot="energy7">
                               <el-input
                                v-model="form.energy7"
                                :disabled="disabled"
                                placeholder="请输入能耗指标"
                                @input="e=>energyInput(e,'energy7')"
                               ></el-input>
                        </template>
                        <template slot="energy8">
                               <el-input
                                v-model="form.energy8"
                                :disabled="disabled"
                                placeholder="请输入能耗指标"
                                @input="e=>energyInput(e,'energy8')"
                               ></el-input>
                        </template>
                        <template slot="energy9">
                               <el-input
                                v-model="form.energy9"
                                :disabled="disabled"
                                placeholder="请输入能耗指标"
                                @input="e=>energyInput(e,'energy9')"
                               ></el-input>
                        </template>
                        <template slot="energy10">
                               <el-input
                                v-model="form.energy10"
                                :disabled="disabled"
                                placeholder="请输入能耗指标"
                                @input="e=>energyInput(e,'energy10')"
                               ></el-input>
                        </template>
                        <template slot="energy11">
                               <el-input
                                v-model="form.energy11"
                                :disabled="disabled"
                                placeholder="请输入能耗指标"
                                @input="e=>energyInput(e,'energy11')"
                               ></el-input>
                        </template>
                        <template slot="energy12">
                               <el-input
                                v-model="form.energy12"
                                :disabled="disabled"
                                placeholder="请输入能耗指标"
                                @input="e=>energyInput(e,'energy12')"
                               ></el-input>
                        </template>
                        <template slot="energyYear">
                               <el-input
                                v-model="form.energyYear"
                                :disabled="disabled"
                                placeholder="请输入能耗指标"
                                @input="e=>energyInput(e,'energyYear')"
                               ></el-input>
                        </template>
                                <template slot="settings">
                                        <meterSetting
                                                :disabled="disabled"
                                                ref="meterSetting"
                                        ></meterSetting>
                                </template>
                                <template slot="menuForm">
                                        <el-button 
                                         :loading="loading"
                                        @click="cancel()">
                                                取消
                                        </el-button>
                                </template>
                                
                        </avue-form>

                </el-dialog>
        </div>
</template>

<script>
import {defaultOption,omitNumber,monthOption,yearOption} from "./form-option";
import {meterTree,add,update,getListByDeptCostId,metergetListByDeptCostId} from "@/api/crmedical/energy/energy-consumption/index.js"
import meterSetting from './meter-setting';
export default {
        components:{
                meterSetting
        },
        props:{

        },
        data(){
                
                return{
                        title:'',
                        deptList:[],
                        disabled:false,
                        loading:false,
                        option:defaultOption,
                        dialogVisible:false,
                        prjectList: [],
                        form: {
                                projectId: "",
                                warehouseId: "",
                                type: "",
                                inboundStatus: "",
                                inboundNo: "",
                                linkNo: "",
                                id:'',
                        },
                        data: [], //入库单列表
                        submitFlag:true,
                }
        },
        watch:{
                'form.costCycleUnit'(val){
                        // if(!val)return;
                        console.log(123)
                        if(val=='2'){
                                this.option.column = monthOption;
                        }else if(val=='3'){
                                this.option.column = yearOption;
                        }
                },
                'form.meterType'(val){
                        if(!val){
                                return;
                        }
                        this.meterTree();
                }
        },
        methods:{
                // 根据部门能耗id获取指标周期集合
                getListByDeptCostId(id){
                        getListByDeptCostId({deptCostId:this.form.id}).then(res=>{
                                if(this.form.costCycleUnit == 2){
                                        res.data.forEach((ele,index) => {
                                                this.form['energy'+(ele.costCycleName)] = ele.costTarget;
                                        });
                                        console.log(this.form)
                                }else{
                                        this.form.energyYear = res.data[0]?res.data[0].costTarget:'';
                                }
                                this.$forceUpdate();
                                console.log(res)
                        })
                },
                // 获取计算公式
                metergetListByDeptCostId(){
                        metergetListByDeptCostId({deptCostId:this.form.id}).then(res=>{
                                console.log(res)
                                this.$refs.meterSetting.setDefaultData({
                                        formula:this.form.calcFormula,
                                        formulas:res.data,
                                        remark:this.form.description,

                                })
                        })
                },
                //     获取仪表名称树
                meterTree(){
                        meterTree(
                                {
                                        projectId:this.form.projectId,
                                        meterType:this.form.meterType,
                                }
                        ).then(res=>{
                                this.$refs.meterSetting.setDataTree(res.data);
                                // this.data = res.data;
                        })
                },
                // 控制输入框数据
                energyInput(val,name){
                        let value = omitNumber(val);
                        this.form[name] = value;
                },
                // 打开弹窗页面
                openDialog(data){
                        
                        this.form={
                                projectId:'',
                                
                                id:'',
                        };
                        
                        this.submitFlag = true;
                        this.option.submitBtn = true;
                        if(data.type=='add'){
                                this.form.costCycleUnit = '2';
                                this.disabled = false;
                                setTimeout(()=>{
                                        let column = this.findObject(this.option.column,'projectId');
                                        console.log(data.dicData.projectIdDictDataList)
                                        console.log(this.option.column)
                                        column.dicData = data.dicData.projectIdDictDataList;
                                        console.log(12323)
                                        this.deptList = data.dicData.deptList;
                                        this.title = '新增';
                                        
                                        this.form.deptId=this.deptList[0]?this.deptList[0].id:'',

                                        this.form.projectId=data.dicData.projectId;
                                        // this.meterTree();
                                        this.option.disabled = false;
                                        this.dialogVisible = true;
                                },0)
                               
                        }
                        if(data.type=='view'){
                                this.option.submitBtn = false;
                                this.form = data.data;
                                this.disabled = true;
                                this.form.meterType = Number(this.form.meterType);
                                this.form.costCycleUnit = String(this.form.costCycleUnit);
                                setTimeout(()=>{
                                        let column = this.findObject(this.option.column,'projectId');
                                        console.log(data.dicData.projectIdDictDataList)
                                        console.log(this.option.column)
                                        column.dicData = data.dicData.projectIdDictDataList;
                                        console.log(12323)
                                        this.deptList = data.dicData.deptList;
                                
                                        this.option.disabled = true;
                                        // this.meterTree();
                                        
                                        this.title = '查看';
                                        this.getListByDeptCostId()
                                        this.metergetListByDeptCostId();

                                        this.dialogVisible = true;
                                },0)

                        }
                        if(data.type=='edit'){
                                this.disabled = false;
                                this.form = data.data;
                                this.form.meterType = Number(this.form.meterType);
                                this.form.costCycleUnit = String(this.form.costCycleUnit);
                                setTimeout(()=>{
                                        
                                        let column = this.findObject(this.option.column,'projectId');
                                        console.log(data.dicData.projectIdDictDataList)
                                        console.log(this.option.column)
                                        column.dicData = data.dicData.projectIdDictDataList;
                                        console.log(12323)
                                        this.deptList = data.dicData.deptList;
                                        
                                        this.meterTree();
                                        this.getListByDeptCostId()
                                        this.title = '编辑';
                                
                                        this.metergetListByDeptCostId();
                                        this.option.disabled = false;
                                        this.dialogVisible = true;
                                },0)
                        }
                        
                        
                },
                getDetail(id,callback){
                        getDetail({id:id}).then(res=>{
                                callback(res.data);
                        })
                },
                formError(...a){
                        console.log(a)
                        // done();
                },
                // 取消
                cancel(){
                        this.dialogVisible = false;
                },
                // 保存 提交    
                applyFor(form,done){

                                let data = this.$refs.meterSetting.getData();
                                        console.log(data)
                                       
                                if(data.success){
                                        form.calcFormula = data.formula;
                                        form.description = data.remark;
                                       
                                        if(form.calcFormula.length>1000){
                                                this.$message.error('公式请不要大于1000字');
                                                        done();
                                                return;
                                        }
                                        console.log(form.description)
                                        if(form.description.length>1000){
                                                this.$message.error('备注请不要大于500字');
                                                        done();
                                                return;
                                        }
                                        form.energySettingDeptCostMeterList = data.meterList;
                                }else{
                                        this.$message.error('错误公式'+data.formula);
                                        
                                        done();
                                        return;
                                        
                                }

                                form.energySettingDeptCostCycleList = [];
                                
                                if(form.costCycleUnit==2){
                                        for(let i = 1;i<=12;i++){
                                                let temOBj = {
                                                        costTarget:form['energy'+i],
                                                        costCycleName:i,
                                                        
                                                };
                                                form.energySettingDeptCostCycleList.push(temOBj);

                                        }
                                }else if(form.costCycleUnit==3){
                                        let temOBj = {
                                                        costTarget:form['energyYear'],
                                                        costCycleName:1,
                                                        
                                                };
                                        form.energySettingDeptCostCycleList.push(temOBj);
                                }
                                if(form.id){
                                        
                                        update(form).then(res=>{
                                         done();
                                        
                                        this.$message({
                                                message: '修改成功',
                                                type: 'success'
                                        });
                                        this.dialogVisible = false;
                                        this.$emit('onLoad');
                                        
                                        }).catch(res=>{
                                                done();
                                        })
                                }else{
                                        add(form).then(res=>{
                                         done();
                                        
                                        this.$message({
                                                message: '提交成功',
                                                type: 'success'
                                        });
                                        this.dialogVisible = false;
                                        this.$emit('onLoad');
                                        
                                        }).catch(res=>{
                                                done();
                                        })
                                }     
                                




                        

                        
                },
        }
}
</script>
